import type { Challenge } from '@/features/journeys'

export type NormalizedChallengeGroup =
  | { kind: 'single'; challenge: Challenge }
  | { kind: 'merged_stories'; challenges: Challenge[] }

function compareByPositionThenId(a: Challenge, b: Challenge) {
  const pa = Number(a.position) || 0
  const pb = Number(b.position) || 0
  if (pa !== pb) return pa - pb
  return a.id - b.id
}

export function groupChallengesForStoryMerge(
  challenges: Challenge[]
): NormalizedChallengeGroup[] {
  if (!challenges.length) return []
  const sorted = [...challenges].sort(compareByPositionThenId)
  const groups: NormalizedChallengeGroup[] = []
  let i = 0

  while (i < sorted.length) {
    const ch = sorted[i]
    if (ch.kind !== 'stories') {
      groups.push({ kind: 'single', challenge: ch })
      i += 1
      continue
    }

    const run: Challenge[] = []
    while (i < sorted.length && sorted[i].kind === 'stories') {
      run.push(sorted[i])
      i += 1
    }

    if (run.length === 1) {
      groups.push({ kind: 'single', challenge: run[0] })
    } else {
      groups.push({ kind: 'merged_stories', challenges: run })
    }
  }

  return groups
}
